export default __webpack_public_path__ + "media/images/logo/sns/line-contained-60f21863a65ce86525041abd902eecd5.png";